// The three signatures of the audit (Dibuat, Diketahui, Diteliti) and the check before signing.
const useEditorSignature = ({
  uiContext,
  headerData,
  setHeaderData,
  pengecekanSaved,
  verify,
}) => {
  // Asks the backend to sign as `verifLabel` (audit_kendaraan:<dibuat | diketahui | diteliti>).
  // The result (id / datetime / data of the signer) is stored in the header under the `verif_<name>_...` fields.
  const sign = async (props, name) => {
    let username = undefined;
    let password = undefined;

    if (props && props.username) {
      username = props.username;
    }

    if (props && props.password) {
      password = props.password;
    }

    return await verify({
      username,
      password,
      label: "staff",
      verifLabel: `audit_kendaraan:${name}`,
      id: headerData.id,
      result_object_id: `verif_${name}_id`,
      result_object_datetime: `verif_${name}_datetime`,
      result_object_data: `data_verif_${name}`,
      data: headerData,
      setData: setHeaderData,
    });
  };

  // handle sign methods
  const handleOnSignDiteliti = async (props) => {
    const verifyResponse = await sign(props, "diteliti");

    if (verifyResponse && verifyResponse.verif_diteliti_id) {
      window.location.reload();
    }
    return verifyResponse;
  };

  const handleOnSignDiketahui = async (props) => {
    return await sign(props, "diketahui");
  };

  const handleOnSignDibuat = async (props) => {
    return await sign(props, "dibuat");
  };

  // the checklist of every bagian has to be saved before "Diketahui" can be signed
  const handleValidateKeamanan = () => {
    if (!pengecekanSaved["bagian_depan"]) {
      uiContext.showErrorMsg("Error", "Pengecekan bagian depan belum di-save");
      return false;
    } else if (!pengecekanSaved["bagian_samping"]) {
      uiContext.showErrorMsg(
        "Error",
        "Pengecekan bagian samping belum di-save"
      );
      return false;
    } else if (!pengecekanSaved["bagian_belakang"]) {
      uiContext.showErrorMsg(
        "Error",
        "Pengecekan bagian belakang belum di-save"
      );
      return false;
    } else if (!pengecekanSaved["bagian_dalam"]) {
      uiContext.showErrorMsg("Error", "Pengecekan bagian dalam belum di-save");
      return false;
    } else {
      return true;
    }
  };

  return {
    handleOnSignDiteliti,
    handleOnSignDiketahui,
    handleOnSignDibuat,
    handleValidateKeamanan,
  };
};

export default useEditorSignature;
